(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.modalEntryAR =  function (){

    var 
      $entryAR                      = $('#js-entryAR'),
      $entryAR_tabclick             = $('.js-entryAR-tab'),
      $entryAR_section              = $('.b-entryAR__section'),
      //$entryAR_forgot_psw_button    = $('#js-forgot-psw-button'),
      $entryAR_forgot_psw_section   = $('#js-entryAR-forgot-psw'),
      $entry_login_section          = $('#js-entryAR-login'),
      $entry_email_psw_section      = $('#js-entryAR-email-psw'),
      $entry_signup_section         = $('#js-entryAR-signup'),
      $entry_email_confirm_section  = $('#js-entryAR-email-confirm'),

    showTab = function(item){
      $entryAR_section.hide();
      $(".b-entryAR__section[data-section-name=" + item + "]").show();
    },

    setActive = function(elem){
      $entryAR_tabclick.removeClass('is-active');
      $(".js-entryAR-tab[data-tab-name=" + elem + "]").addClass('is-active');
    },

    initCarousel = function(){
      // Carousel signup
      $('.b-entryAR__slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        autoplaySpeed: 4000,
        autoplay: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        draggable: true
      });
    },

    // Posiziona correttamente il carousel signup
    setCarouselPosition = function(){
      $('.b-entryAR__slider').slick('setPosition');
    };

    // Click sui Tabs
    $entryAR_tabclick.click(function(e){
      e.preventDefault();
      var target = $(this).attr('data-tab-name');
      showTab( target );
      setActive( target );
      setCarouselPosition();
    });

    // Click su "indietro"
    $('.js-entryAR-goback').click(function(e){
      //e.preventDefault();
      $.gnv.modalEntryAR.goBack($(this), e);
//      var target = $(this).attr('data-tab-name');
//      showTab( target );
//      setCarouselPosition();
    });

    // Click su "dimenticato password"
    $('#js-forgot-psw-button').click(function(e){
      $entry_login_section.hide();
      $entryAR_forgot_psw_section.show();
    });


    // Click su "recupera password"
//    $('.js-btn-recover-psw').click(function(e){
//      $entryAR_forgot_psw_section.hide();
//      $entry_email_psw_section.show();
//    });

    $.gnv.modalEntryAR.activatePanelSentMailResetPwd = function() {
	  $($entryAR_forgot_psw_section).hide();
	  $($entry_email_psw_section).show();
    }

    // Click su "registrati"
 //   $('.js-signup-button').click(function(e){
//      $entry_signup_section.hide();
//      $entry_email_confirm_section.show();
//    });

    $.gnv.modalEntryAR.activatePanelSentMailActivation = function() {
	  $($entry_signup_section).hide();
	  $($entry_email_confirm_section).show();
    }

    $.gnv.modalEntryAR.goBack = function(elem, event) {
	  event.preventDefault();
      var target = elem.attr('data-tab-name');
      showTab( target );
      setCarouselPosition();
	}

    $("#js-entryAR-signup form").submit(function(e){
      e.preventDefault();
    });

    // Click su qualsiasi link che apre la modale
    $('.js-entryAR-linkTo').click(function(e){
      e.preventDefault();
      var target = $(this).attr('data-tab-name');
      showTab( target );
      setActive( target );
      $(window).resize();
    });

    $('.b-inviteLogin__close').click(function(e){
      e.preventDefault();
      $('.b-inviteLogin').removeClass('is-visible').addClass('is-closed');
    });
	
	$('.js-entryPnr').click(function(e){
		e.preventDefault();
		$('#js-entryAR li').each(function()
		{
			if($(this).attr('data-tab-name')=="entryAR-pnr")
			{$(this).addClass('is-active')}
			else
			{$(this).removeClass('is-active')}
		});
		showTab($('.js-entryAR-activation li.is-active').attr('data-tab-name'));
		
	});
	
	$('.js-entryAR').click(function(e){
		e.preventDefault();
		$('#js-entryAR li').each(function()
		{
			if($(this).attr('data-tab-name')=="entryAR-signup")
			{$(this).addClass('is-active')}
			else
			{$(this).removeClass('is-active')}
		});
		showTab($('.js-entryAR-activation li.is-active').attr('data-tab-name'));

	});

    $( document ).ready(function() {
//      initCarousel();
//	  showTab($('.js-entryAR-activation li:first').attr('data-tab-name'));
	  showTab($('.js-entryAR-activation li.is-active').attr('data-tab-name'));
    });
  };
  $.gnv.modalEntryAR();

})(jQuery);

function login(href, formId, event) {
	event.preventDefault();

	var $form = $('#' + formId);
	if(!submitFormValidator($form ,$(href)))
	{	
		return false 
	}

	var csrfToken = $("meta[name='_csrf']").attr("content");
	var csrfHeader = $("meta[name='_csrf_header']").attr("content");

	addSpinnerOnBtn(href);
	$.ajax({
		url:        emConf.baseUrl + "/account/login",
		async:      true,
		type:       "POST",
		data:      	$form.serialize(),
		dataType:   "json",
		beforeSend: function (request) {
			if (csrfToken != '${_csrf.token}') {
				request.setRequestHeader(csrfHeader, csrfToken);
			}
        },
		success:    function ( data ) {
			if (data.errorCode != null) {
				var elem = "";
				var errorCode;

				errorCode = data.errorCode;
				if (errorCode == "loginError") {
					elem = href;
				}
				else {
					elem = href;
					errorCode = "errorUnknown";
				}
				showError(errorCode, elem);
			}
			else if (data.url != null) {
				window.location = data.url;
			}
			removeSpinnerOnBtn(href);
		},
	    error: function(jqXHR, textStatus, errorThrown) {
            showError("errorUnknown", href);
            removeSpinnerOnBtn(href);
	    }
	});
}


function sendResetPasswordRequest(href, formId, username, event) {
	event.preventDefault();
	
	var $form = $('#' + formId);
	if(!submitFormValidator($form ,$(href)))
	{	
		return false 
	}

	var csrfToken = $("meta[name='_csrf']").attr("content");
	var csrfHeader = $("meta[name='_csrf_header']").attr("content");

	addSpinnerOnBtn(href);
	$.ajax({
		url:        emConf.baseUrl + "/account/resetPasswordRequest",
		async:      true,
		type:       "POST",
		data:      	$form.serialize(),
		dataType:   "json",
		beforeSend: function (request) {
			if (csrfToken != '${_csrf.token}') {
				request.setRequestHeader(csrfHeader, csrfToken);
			}
        },
		success:    function ( data ) {
			if (data.errorCode != null) {
				var elem = "";
				var errorCode;

				errorCode = data.errorCode;
				if (errorCode == "usernameNotFound") {
					elem = username;
				}
				else if (errorCode == "userNotActivated") {
					elem = username;
				}
				else {
					elem = href;
					errorCode = "errorUnknown";
				}
				showError(errorCode, elem);
			}
			else {
				$.gnv.modalEntryAR.activatePanelSentMailResetPwd();
			}
			removeSpinnerOnBtn(href);
		},
	    error: function(jqXHR, textStatus, errorThrown) {
            showError("errorUnknown", href);
            removeSpinnerOnBtn(href);
	    }
	});
}

function resetPasswordAction(href, formId, pwdNew,  pwdConfirm, panelResetPwd, panelCongratulations, event) {
	event.preventDefault();

	var $form = $('#' + formId);
	if(!submitFormValidator($form ,$(href)))
	{	
		return false 
	}

	var csrfToken = $("meta[name='_csrf']").attr("content");
	var csrfHeader = $("meta[name='_csrf_header']").attr("content");

	addSpinnerOnBtn(href);
	$.ajax({
		url:        emConf.baseUrl + "/account/resetPasswordAction",
		async:      true,
		type:       "POST",
		data:      	$form.serialize(),
		dataType:   "json",
		beforeSend: function (request) {
			if (csrfToken != '${_csrf.token}') {
				request.setRequestHeader(csrfHeader, csrfToken);
			}
        },
		success:    function ( data ) {
			if (data.errorCode != null) {
				var elem = "";
				var errorCode;

				errorCode = data.errorCode;
				if (errorCode == "pwdEmpty") {
					elem = pwdNew;
				}
				else if (errorCode == "confirmPwdNoMatch") {
					elem = pwdConfirm;
				}
				else if (errorCode == "wrongCredential") {
					elem = href;
				}
				else {
					elem = href;
					errorCode = "errorUnknown";
				}
				showError(errorCode, elem);
			}
			else {
				$('#' + panelResetPwd).hide();
				$('#' + panelCongratulations).show();
			}
			removeSpinnerOnBtn(href);
		},
	    error: function(jqXHR, textStatus, errorThrown) {
            showError("errorUnknown", href);
            removeSpinnerOnBtn(href);
	    }
	});
}

function completeRegistration(href, formId, event) {	
	var $form = $('#' + formId);
	if(!submitFormValidator($form ,$(href))) {
		event.preventDefault();
		return false 
	}
	document.getElementById(formId).submit();
}

function registration(href, formId, email,  pwdConfirm, event) {	
	event.preventDefault();
	
	var $form = $('#' + formId);
	if(!submitFormValidator($form ,$(href)))
	{	
		return false 
	}

	var csrfToken = $("meta[name='_csrf']").attr("content");
	var csrfHeader = $("meta[name='_csrf_header']").attr("content");

	addSpinnerOnBtn(href);
	$.ajax({
		url:        emConf.baseUrl + "/account/registration",
		type:		"POST",
		data:      	$form.serialize(),
		dataType:   "html",
		beforeSend: function (request) {
			if (csrfToken != '${_csrf.token}') {
				request.setRequestHeader(csrfHeader, csrfToken);
			}
        },
		success: function (data) {
			var resultStatus;
			var status;
			var elem = "";
			var errorCode;

			resultStatus = $('#result-status', data);
			if (resultStatus != null) {
				status = resultStatus.data("status");
			} 
			if (status == "mailSentActivation") {
				$.gnv.modalEntryAR.activatePanelSentMailActivation();
			} else if (status == "mailSentConfirmation") {

			} else if (status == "error") {
				var errorCode;
				
				errorCode = resultStatus.data("error-code");
				if (errorCode == "confirmPwdNoMatch") {
					elem = pwdConfirm;
				}
				else if (errorCode == "userNotActivated") {
					elem = email;
				}
				else if (errorCode == "userAlreadyExists") {
					elem = email;
				}
				else {
					elem = href;
					errorCode = "errorUnknown";
				}
				showError(errorCode, elem);
			}
			removeSpinnerOnBtn(href);
		},
	    error: function(jqXHR, textStatus, errorThrown) {
			showError("errorUnknown", href);
	    	removeSpinnerOnBtn(href);
	    }
	});
}


function changePassword(href, formId, pwdOld,  pwdNew,  pwdConfirm, panelResetPwd, panelCongratulations, event) {
	event.preventDefault();

	var $form = $('#' + formId);
	if(!submitFormValidator($form ,$(href)))
	{	
		return false 
	}

	var csrfToken = $("meta[name='_csrf']").attr("content");
	var csrfHeader = $("meta[name='_csrf_header']").attr("content");
	
	addSpinnerOnBtn(href);
	$.ajax({
		url:        emConf.baseUrl + "/account/changePassword",
		async:      true,
		type:       "POST",
		data:      	$form.serialize(),
		dataType:   "json",
		beforeSend: function (request) {
			if (csrfToken != '${_csrf.token}') {
				request.setRequestHeader(csrfHeader, csrfToken);
			}
        },
		success:    function ( data ) {
			if (data.errorCode != null) {
				var elem = "";
				var errorCode;

				errorCode = data.errorCode;
				
				if ((errorCode == "oldPwdEmpty") || (errorCode == "wrongCredential"))  {
					elem = pwdOld;
				}
				else if (errorCode == "pwdEmpty") {
					elem = pwdNew;
				}
				else if (errorCode == "confirmPwdNoMatch") {
					elem = pwdConfirm;
				}
				else {
					elem = href;
					errorCode = "errorUnknown";
				}
				showError(errorCode, elem);
			}
			else {
				$('#' + panelResetPwd).hide();
				$('#' + panelCongratulations).show();
			}
			removeSpinnerOnBtn(href);
		},
	    error: function(jqXHR, textStatus, errorThrown) {
            showError("errorUnknown", href);
            removeSpinnerOnBtn(href);
	    }
	});
}

function closeEmModal(modalId, redirectUrlOnClosing, functionOnClose, onCloseParams) {
	var $modal = $('[data-remodal-id=' + modalId + ']');		
	if (redirectUrlOnClosing && 'string' == typeof redirectUrlOnClosing){
		$modal.data('redirect-url-on-close', redirectUrlOnClosing)
	} else if (functionOnClose && typeof window[functionOnClose] === "function") {
		$modal.data('function-on-close', functionOnClose)
		if (onCloseParams) {
			$modal.data('on-close-params', onCloseParams);
		}
	}
	$modal.remodal().close();
}


function cancellationRequest(remodalTargetId, idReservation, pnr, cancellationFeeToPay) {
	
	openEmModal(remodalTargetId);
	if (cancellationFeeToPay) {
		var csrfToken = $("meta[name='_csrf']").attr("content");
		var csrfHeader = $("meta[name='_csrf_header']").attr("content");
		$.ajax({
			url:        emConf.baseUrl + "/account/cancellation-request",
			async:      true,
			type:       "POST",
			data:       {
				idReservation: idReservation, 
				pnr: pnr
			},
			dataType:   "json",
			beforeSend: function (request) {
				if (csrfToken != '${_csrf.token}') {
					request.setRequestHeader(csrfHeader, csrfToken);
				}
			},
			success:    function ( data ) {
				if (data.errorCode == null) {
					var divInfo = $("#reservation-cancel-info");
					$(divInfo ).show();
					$(divInfo ).find(".toPopolate").each(function (index, el) {
						var field = $(el).data('popolate-with');					
						var value = data[field];
						if ($(el).is("input")) {
							$(el).val(value);	
						} else {
							$(el).html(value);
						}								
					});
				}
				else if (data.errorCode == "communication-error") {
					$('#info-cancellation-fee').hide();
					$('#error-cancellation-fee').show();
					$('#reservation-cancel-info').show();
				}
				else {
					var fieldToShow;

					if (data.errorCode == "booking-not-found") {
						fieldToShow = "reservation-cancel-error-communication";
					}
					else if (data.errorCode == "booking-expired") {
						fieldToShow = "reservation-cancel-error-bookingExpired";
					}
					else {
						fieldToShow = "reservation-cancel-error-communication";
					}
					$('#' + fieldToShow).show();
					$('#reservation-cancel-finalMessage').show();
					$('#reservation-cancel-info-container').hide();
				}
				$('#reservation-cancel-spinner').hide();
			},
			error: function(jqXHR, textStatus, errorThrown) {
				$('#reservation-cancel-error-communication').show();
				$('#reservation-cancel-finalMessage').show();
				$('#reservation-cancel-info-container').hide();
				$('#reservation-cancel-spinner').hide();
			}
		});
	}
}

function cancellationAction(href, formId, event) {
	event.preventDefault();

	var $form = $('#' + formId);
	var csrfToken = $("meta[name='_csrf']").attr("content");
	var csrfHeader = $("meta[name='_csrf_header']").attr("content");
	
	addSpinnerOnBtn(href);
	$.ajax({
		url:        emConf.baseUrl + "/account/cancellation-action",
		async:      true,
		type:       "POST",
		data:      	$form.serialize(),
		dataType:   "json",
		beforeSend: function (request) {
			if (csrfToken != '${_csrf.token}') {
				request.setRequestHeader(csrfHeader, csrfToken);
			}
        },
		success:    function ( data ) {
			console.log(data);

			var fieldToShow = 'reservation-cancel-finalMessage-done';
			
			if (data.errorCode != null) {
				var errorCode;

				errorCode = data.errorCode;
				if (errorCode == "booking-not-found") {
					fieldToShow = "reservation-cancel-error-communication";
				}
				else if (errorCode == "booking-not-cancellable") {
					fieldToShow = "reservation-cancel-error-notCancellable";
				}
				else {
					fieldToShow = "reservation-cancel-error-communication";
				}
			}
			else {
				if (data.deferred) {
					fieldToShow = 'reservation-cancel-finalMessage-deferred';
				} else {
					if ('OK' != data.refund) {
						fieldToShow = 'reservation-cancel-finalMessage-onWorking';	
					}
				}
			}
			$('#' + fieldToShow).show();
			showModalResponse(formId);
			//$('#reservation-cancel-finalMessage').show();
			//$('#reservation-cancel-info-container').hide();
			removeSpinnerOnBtn(href);
		},
	    error: function(jqXHR, textStatus, errorThrown) {
			$('#reservation-cancel-error-communication').show();
			showModalResponse(formId);
			//$('#reservation-cancel-finalMessage').show();
			//$('#reservation-cancel-info-container').hide();
	    	removeSpinnerOnBtn(href);
	    }
	});
}



/* ------------------------- gestione delle modali di invio richieste assistenza zendesk ------------------------- */

function showModalResponse(formId){
	var modal = $('#'+formId).parents('.js-modal-content');
	modal.find('.js-modal-response').show();
	modal.find('.js-modal-request').hide();
}
function resetModalMessages(modalObj){
	//nascondo il messaggio di risposta
	$(modalObj).find('.js-modal-response').hide();
	// pulisco i valori nei campi inseriti
	$(modalObj).find("input[type!='hidden'], textarea").val('')
	//rimuovo le validazioni
	clearValidateBlock($(modalObj))
	// rimetto visibile la view iniziale
	$(modalObj).find('.js-modal-request').show();
}

$(document).on('closed', '.js-modal-content', function (e) {
	resetModalMessages(this);
});

/* ------------------------- fine gestione delle modali di invio richieste assistenza zendesk  -------------------------  */

function getStatement(href, remodalId, formId, validate, event) {
	event.preventDefault();
	
	var $form = $('#' + formId);
	if (validate) 
	{
		if(!submitFormValidator($form ,$(href)))
		{	
			return false 
		}
	}
	$form.submit();
	closeEmModal(remodalId);
}

function evalJSFromHtml(html) {
  var newElement = document.createElement('div');
  newElement.innerHTML = html;

  var scripts = newElement.getElementsByTagName("script");
  for (var i = 0; i < scripts.length; ++i) {
    var script = scripts[i];
    eval(script.innerHTML);
  }
}